module.exports = __webpack_public_path__ + "img/modular03.13503214.png";